import { useNavigate } from "react-router-dom";

const IntroScreen = () => {
  const navigate = useNavigate();
  const today = new Date();
  const dayName = today.toLocaleDateString("en-US", { weekday: "long" });
  const monthName = today.toLocaleDateString("en-US", { month: "long" });
  const dayNumber = today.toLocaleDateString("en-US", { day: "numeric" });
  const yearNumber = today.toLocaleDateString("en-US", { year: "numeric" });

  return (
    <section id="screen-intro" className="screen active">
      {/* Decorative Elements */}
      <div className="deco-glow glow-1"></div>
      <div className="deco-glow glow-2"></div>
      <div className="deco-glow glow-3"></div>

      {/* Left Side Hanging Hearts */}
      <div className="hanging-hearts-cluster left">
        <div
          className="heart-string"
          style={{ "--length": "60px", "--delay": "0s" }}
        >
          <span className="heart-icon">💝</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "80px", "--delay": "0.2s" }}
        >
          <span className="heart-icon">💖</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "50px", "--delay": "0.4s" }}
        >
          <span className="heart-icon">💕</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "70px", "--delay": "0.6s" }}
        >
          <span className="heart-icon">💗</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "55px", "--delay": "0.8s" }}
        >
          <span className="heart-icon">💓</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "75px", "--delay": "1s" }}
        >
          <span className="heart-icon">💘</span>
        </div>
      </div>

      {/* Right Side Hanging Hearts */}
      <div className="hanging-hearts-cluster right">
        <div
          className="heart-string"
          style={{ "--length": "65px", "--delay": "0.1s" }}
        >
          <span className="heart-icon">💝</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "85px", "--delay": "0.3s" }}
        >
          <span className="heart-icon">💖</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "45px", "--delay": "0.5s" }}
        >
          <span className="heart-icon">💕</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "72px", "--delay": "0.7s" }}
        >
          <span className="heart-icon">💗</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "58px", "--delay": "0.9s" }}
        >
          <span className="heart-icon">💓</span>
        </div>

        <div
          className="heart-string"
          style={{ "--length": "78px", "--delay": "1.1s" }}
        >
          <span className="heart-icon">💘</span>
        </div>
      </div>

      {/* Floating Paper Plane */}
      <div className="paper-plane-container">
        <svg className="paper-plane" viewBox="0 0 100 80" fill="none">
          <defs>
            <linearGradient id="planeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF69B4" />
              <stop offset="100%" stopColor="#FF1493" />
            </linearGradient>
          </defs>
          <path
            d="M5 40L95 5L55 75L50 45L5 40Z"
            fill="url(#planeGrad)"
            stroke="#C71585"
            strokeWidth="1.5"
          />
          <path d="M50 45L95 5" stroke="#FFB6C1" strokeWidth="1" />
        </svg>
        <div className="plane-trail"></div>
      </div>

      {/* Calendar Widget */}
      <div className="calendar-widget">
        <div className="calendar-rings">
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="ring"></div>
        </div>
        <div className="calendar-body">
          <span className="day-name">{dayName}</span>
          <span className="date-num">{dayNumber}</span>
          <span className="month-name">{monthName}</span>
          <span className="year">{yearNumber}</span>
        </div>
        <div className="calendar-hearts">
          <span>💕</span>
          <span>💖</span>
          <span>💝</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="intro-content">
        {/* Title */}
        <div className="title-container">
          <h1 className="main-title">
            <span className="title-line">Hey Sakhi</span>
            <span className="title-line highlight">Will you Marry Me?</span>
          </h1>
          <div className="title-hearts">
            <span className="th-1">💝</span>
            <span className="th-2">💖</span>
            <span className="th-3">💕</span>
          </div>
        </div>

        {/* Buttons */}
        <div className="button-group">
          <button
            id="btn-yes"
            className="btn btn-primary btn-glow"
            onClick={() => navigate("/success")}
          >
            <span className="btn-icon">💍</span>
            <span className="btn-text">YES, OF COURSE!</span>
            <div className="btn-shine"></div>
          </button>
          <button
            id="btn-no"
            className="btn btn-secondary"
            onClick={() => navigate("/sad")}
          >
            <span className="btn-icon">😢</span>
            <span className="btn-text">No, thank you</span>
          </button>
        </div>
      </div>

      {/* Bottom Hearts */}
      <div className="bottom-hearts">
        <span className="bh-1">💗</span>
        <span className="bh-2">💖</span>
        <span className="bh-3">💝</span>
        <span className="bh-4">💕</span>
        <span className="bh-5">💘</span>
      </div>
    </section>
  );
};

export default IntroScreen;
